export function jobCompoundType(job) {
  let compoundType = job.type;
  if (job.type === "simulate") {
    compoundType += "." + (job.simulator?.type ?? "unknown");
  }
  return compoundType;
}
